import * as React from "react";
import { CountDownBox, Time, CountDIcon } from "./styled";
import { formatSecToDate } from "../../../../utils/playground/flashProduct";
const CountDown = (props) => {
    var _a, _b;
    const { countInfo, style, needIcon = true } = props;
    const [endTime, setEndTime] = React.useState(+((countInfo === null || countInfo === void 0 ? void 0 : countInfo.countdownToEnd) || 0));
    const tick = () => {
        setEndTime(preTime => {
            return preTime - 1;
        });
    };
    React.useEffect(() => {
        let timerID = setInterval(() => {
            if (endTime > 0) {
                tick();
            }
        }, 1000);
        return () => clearInterval(timerID);
    });
    if (!((_a = props === null || props === void 0 ? void 0 : props.countInfo) === null || _a === void 0 ? void 0 : _a.countdownToEnd)) {
        return null;
    }
    if (endTime <= 0) {
        return null;
    }
    return (React.createElement(CountDownBox, { style: Object.assign({}, style) },
        needIcon && (React.createElement(CountDIcon, { className: (_b = countInfo === null || countInfo === void 0 ? void 0 : countInfo.uiOptions) === null || _b === void 0 ? void 0 : _b.icon })),
        React.createElement(Time, null, formatSecToDate(endTime))));
};
export default CountDown;
